import { Container, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteAccount } from 'apis/authentication.api';
import LanguageSwitcherWrap from 'components/elements/LanguageSwitcherWrap';
import { useTranslation } from 'react-i18next';
const styles = {
	main: {
		padding: '50px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	button: {
		marginTop: '50px',
		marginBottom: '50px'
	}
};

const DeleteAccount = () => {
	const [loading, setLoading] = useState(false);
	const [showSuccessMessage, setShowSuccessMessage] = useState(false);

	const dispatch = useDispatch();
	const { t } = useTranslation();

	const handleClickDelete = async () => {
		setLoading(true);
		const res = await dispatch(deleteAccount());
		setLoading(false);
		if (res?.success) {
			setShowSuccessMessage(true);
		}
	};

	return (
		<LanguageSwitcherWrap>
			<Container sx={styles.main} maxWidth='sm'>
				<Typography component='h4' variant='h4' align='center' color='textPrimary' gutterBottom>
					{t('Delete Your Account')}
				</Typography>
				{!showSuccessMessage && (
					<LoadingButton
						size='large'
						sx={styles.button}
						variant='contained'
						color='primary'
						loading={loading}
						onClick={handleClickDelete}
					>
						{t('Initiate Account Deletion')}
					</LoadingButton>
				)}
				{showSuccessMessage && (
					<Typography variant='h6' align='center' color='textSecondary' paragraph>
						{t('Your account deletion request has been received')}.{' '}
						{t('Our support team will follow up to confirm your account has been deleted')}.
					</Typography>
				)}
			</Container>
		</LanguageSwitcherWrap>
	);
};

export default DeleteAccount;
